var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 48,
    viewBox: "0 0 68 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_31034)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18_31034)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_18_31034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 0.5H3C1.61929 0.5 0.5 1.61929 0.5 3V37C0.5 38.3807 1.61929 39.5 3 39.5H57C58.3807 39.5 59.5 38.3807 59.5 37V3C59.5 1.61929 58.3807 0.5 57 0.5Z",
    fill: "white",
    stroke: "#D5DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7505 26.6165H16.0291L13.2385 15.9703C13.106 15.4806 12.8248 15.0476 12.4111 14.8436C11.3787 14.3308 10.2411 13.9227 9 13.7168V13.307H14.9949C15.8222 13.307 16.4428 13.9227 16.5462 14.6377L17.9941 22.3172L21.7137 13.307H25.3316L19.7505 26.6165ZM27.4003 26.6165H23.8857L26.7797 13.307H30.2943L27.4003 26.6165ZM34.8411 16.9941C34.9446 16.2773 35.5651 15.8674 36.289 15.8674C37.4267 15.7645 38.6659 15.9703 39.7002 16.4813L40.3207 13.6157C39.2865 13.2058 38.1488 13 37.1164 13C33.7053 13 31.2232 14.8436 31.2232 17.4022C31.2232 19.3487 32.9813 20.3707 34.2224 20.9864C35.5651 21.6004 36.0822 22.0103 35.9788 22.6242C35.9788 23.5451 34.9446 23.955 33.9121 23.955C32.6711 23.955 31.43 23.648 30.2942 23.1352L29.6737 26.0026C30.9147 26.5136 32.2574 26.7194 33.4985 26.7194C37.3233 26.8206 39.7002 24.9788 39.7002 22.2143C39.7002 18.733 34.8411 18.5289 34.8411 16.9941ZM52.0002 26.6165L49.2096 13.307H46.2122C45.5917 13.307 44.9711 13.7168 44.7643 14.3308L39.5968 26.6165H43.2148L43.9369 24.6718H48.3822L48.7959 26.6165H52.0002ZM46.7289 16.8912L47.7613 21.9073H44.8673L46.7289 16.8912Z",
    fill: "#172B85"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_31034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18_31034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_18_31034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterImg);
export default __webpack_public_path__ + "static/media/FooterImg.3f99c2ac394e0dee58f1707bebb7cbe1.svg";
export { ForwardRef as ReactComponent };